export default __webpack_public_path__ + "static/media/avi.7af354e7.jpg";